import { createTypes } from "redux-create-types";
import { fromType } from "kreighter";

const namespace = "libraryDocument";

export const libraryDocumentActions = createTypes(["save"], namespace);

export const libraryDocumentActionsCreators = {
    save: fromType(libraryDocumentActions.save, ["document", "courseId"])
};
